"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleFormSubmission = exports.FormHandler = void 0;
const FormValidators_1 = require("../decorators/form/FormValidators");
const form_1 = require("../utils/form");
const salesforce_1 = require("../services/salesforce");
const formDataLayer_1 = require("./utils/formDataLayer");
const endpoints_1 = require("./utils/endpoints");
const postFunctions_1 = require("../services/postFunctions");
const endpoints = new endpoints_1.default;
const postFunctions = new postFunctions_1.default(endpoints.baseURL, endpoints.registerEnv);
class FormHandler {
    static submitForm(form, formData) {
        return __awaiter(this, void 0, void 0, function* () {
            postFunctions.getPostAttribute(form);
        });
    }
}
exports.FormHandler = FormHandler;
function handleFormSubmission(form) {
    return __awaiter(this, void 0, void 0, function* () {
        form.addEventListener('submit', (event) => __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            postFunctions.disableBtn(form, true);
            const formData = (0, form_1.handleFormData)(form);
            const errorMessage = yield (0, FormValidators_1.validateForm)(form);
            if (errorMessage) {
                (0, salesforce_1.upsertSalesforce)(form);
                postFunctions.disableBtn(form, false);
                console.log(form);
            }
            else {
                try {
                    const response = yield FormHandler.submitForm(form, formData);
                    (0, formDataLayer_1.sendDataLayer)(form);
                    (0, salesforce_1.upsertSalesforce)(form);
                    console.log(response);
                }
                catch (error) {
                    console.error('Form submission error:', error);
                }
            }
        }));
    });
}
exports.handleFormSubmission = handleFormSubmission;
